export default "__VITE_ASSET__BnvZBuBx__"